export const CPS_UI_ADMIN_CONFIG_TYPE = {
  MESSAGE_BAR: 'messageBar',
  MAINTENANCE_PAGE: 'maintenancePage',
  HELP_CENTER: 'helpCenter',
  REPORT_ISSUE: 'reportIssue',
  PERMISSION_MANAGEMENT: 'permissionManagement',
  ABOUT: 'about'
} as const;

export type CpsUiAdminConfigType = (typeof CPS_UI_ADMIN_CONFIG_TYPE)[keyof typeof CPS_UI_ADMIN_CONFIG_TYPE];
